import { SimpleEntityActions } from '@app/classes';
import { ModelMixin } from '../core/base-generic.model';

export class Industry extends ModelMixin<Industry>() {
    static permission = new SimpleEntityActions('company');

    protected static _resource = 'companyManagement/industries';

    protected static _version = 'v2';

    protected static _serializeAttributes = ['groupCode', 'groupName', 'enabled'];
    protected static _datetimes = ['createdAt', 'updatedAt', 'deletedAt'];

    get groupCode(): string {
        return this._attributes['groupCode'];
    }

    get groupName(): string {
        return this._attributes['groupName'];
    }

    get enabled(): boolean {
        return this._attributes['enabled'];
    }
}
